import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
const iconUrl = 'assets/img/marker-icon.png';
const Defaulticon = L.icon({
    iconUrl,
    iconSize: [25, 25],
    iconAnchor: [5, 20],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerFormIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
L.Marker.prototype.options.icon = Defaulticon;

@Component({
    selector: 'app-generic_map',
    templateUrl: './generic-map.component.html',
    styleUrls: ['./generic-map.component.scss']
})
export class GenericMapComponent implements OnInit {

    public operation: "point" | "multi-point"
    private map;
    public myLocation: L.LatLng = L.latLng(0, 0);
    public selectedLocation: L.LatLng;
    public markerOpen = false;
    public latitude = 0;
    public longitude = 0;
    public points = "";
    constructor(
        public dialogRef: MatDialogRef<GenericMapComponent>,
        public _translateService: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data,
        public _toastService: ToasterService
    ) {
    }

    ngOnInit(): void {
        this.initMap();
        if (this.operation == "multi-point") {
            this.drawPoligons();
        }
    }


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    private async initMap(): Promise<void> {

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 8
        });

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });
        tiles.addTo(this.map);

        if (this.operation != "multi-point") {
            setTimeout(() => {
                const marker = L.marker([this.latitude, this.longitude], {
                    icon: new ContainerFormIcon({ iconUrl: 'assets/img/marker.png' })
                });
                marker.addTo(this.map)
                this.map.flyTo(new L.LatLng(this.latitude, this.longitude), 19)
            }, 1000)
        }
    }

    async drawPoligons() {
        var poligonList = new Array();
        let points = this.points.split("*");
        points.forEach((item: any) => {
            var location = item.split([","]);
            poligonList.push(new L.LatLng(location[0], location[1]));
        });
        var firstpolyline = new L.polygon(poligonList, {
            color: 'gray',
            weight: 3,
            opacity: 0.3,
            smoothFactor: 1
        });
        this.map.addLayer(firstpolyline);
        var center = firstpolyline.getBounds().getCenter();
        setTimeout(()=>{
            this.map.flyTo(new L.LatLng(center.lat!, center.lng!),15);
        },1000)
    }
}
